import './vice/index.css';

window.nn.registerModule('dualStream', (el, config) => {
  el.innerHTML = require('./vice/index.tpl.html');

  let leftvideo = document.getElementById('leftvideo');
  leftvideo.setAttribute('data-account', config.account);
  leftvideo.setAttribute('data-player', config.player);
  leftvideo.setAttribute('data-video-id', config.leftVideoId);

  let rightvideo = document.getElementById('rightvideo');
  rightvideo.setAttribute('data-account', config.account);
  rightvideo.setAttribute('data-player', config.player);
  rightvideo.setAttribute('data-video-id', config.rightVideoId);

  const script = document.createElement('script');
  script.src = 'https://players.brightcove.net/3879528199001/72nneLxQC_default/index.min.js';
  script.type = 'text/javascript';
  document.head.appendChild(script);

  script.onload = () => {
    import(/* webpackChunkName: "vice" */ './vice');
  };
});
